import _ from 'lodash';
import React from 'react';
import PropTypes, { number } from 'prop-types';
import Radium from 'radium';
import scrollIntoView from 'scroll-into-view';
import { fromJS } from 'immutable';

import * as styles from '../../styles';
import { printExamination } from './render';
import { request } from '../../containers/actions';
import {
    updateQuestionLayout, updateAnswerLayout, reorder, addElement, setLayoutOptions,
    ITEM_TYPE_GLOBAL, ITEM_TYPE_HIDDEN, ITEM_TYPE_STYLE
} from './actions';
import { updateQuestion } from '../questions/actions';
import Item from './item';


//@Radium
export default class Layout extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    state = {
        view: 1,
        active: null,
        edit: null,
        scale: 1,
        template:null
    }

    isInPage(item, page) {
        var qp = item.page;
        var quId = item.question_id;
        var index = item.index;
        if (item.page === ITEM_TYPE_HIDDEN)
            return false;
        if (item.page === ITEM_TYPE_STYLE)
            return !this.props.store.getIn(['settings', 'noStylePages', String(this.state.view), String(page)]);
        if (item.page === ITEM_TYPE_GLOBAL)
            return true;
        var res = (item.page || 0) === page;
        return res;
    }

    refreshLayout(items, updater) {
        if (!window.confirm(window.gettext('Are you sure you wanna refresh layout?')))
            return;
        // debugger;
        this.context.store.dispatch(updater(
            items.filter(item => item.get('question_id')).map(item => item.merge({
                top: null,
                right: null,
                width: null,
                height: null,
                page: null,
            })).sortBy(item => Number(item.get('index'))).toList(),
            this.props.store.get('elementId'),
        ));

    }

    constructor(props) {
        super(props);
        this.elementLoaded = this.elementLoaded.bind(this);
        this.prerenderCallback = this.prerenderCallback.bind(this);
        this.scoresPrerenderCallback = this.scoresPrerenderCallback.bind(this);
        this.setEdit = this.setEdit.bind(this);
        this.setActive = this.setActive.bind(this);
        this.isInPage = this.isInPage.bind(this);
        this.refreshLayout = this.refreshLayout.bind(this);
    }

    componentDidMount() {
        this.userSelect = document.body.style.userSelect;
        document.body.style.userSelect = 'none';
        const handleScroll = () => {
            if (this.refs.navigator) {
                const scroll = window.scrollY;
                const container = document.getElementById('page');
                const top = this.refs.navigatorContainer.offsetTop - container.offsetTop;
                if (scroll > top) {
                    this.refs.navigator.style.position = 'fixed';
                    this.refs.navigator.style.top = container.offsetTop + 'px';
                    this.refs.navigator.style.width = '8.5em';
                }
                else {
                    this.refs.navigator.style.position = 'relative';
                    this.refs.navigator.style.top = '';
                    this.refs.navigator.style.width = '';
                }
            }
            if (this.refs.tools) {
                const scroll = window.scrollY;
                const container = document.getElementById('page');
                const top = this.refs.toolsContainer.offsetTop - container.offsetTop;
                if (scroll > top) {
                    this.refs.tools.style.position = 'fixed';
                    this.refs.tools.style.top = container.offsetTop + 'px';
                    this.refs.tools.style.width = '3em';
                }
                else {
                    this.refs.tools.style.position = 'relative';
                    this.refs.tools.style.top = '';
                    this.refs.tools.style.width = '';
                }
            }
        };
        const clearActive = ({ target }) => {
            if (
                !this.state.edit &&
                !_.some(_.filter(this.refs, (__, key) => key.startsWith('item-')), element => element.refs.item.contains(target)) &&
                (
                    !target.closest ||
                    !target.closest('.mce-floatpanel')
                )
            )
                this.setActive(null);
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        window.addEventListener('mouseup', clearActive, true);
        this.cleanUp = () => {
            document.body.style.userSelect = this.userSelect;
            window.removeEventListener('scroll', handleScroll, { passive: true });
            window.removeEventListener('mouseup', clearActive, true);
        };
        this.setState({...this.state , template: this.props.store.getIn(['settings', 'template'])})
    }

    componentWillUnmount() {
        this.cleanUp();
    }

    elementLoaded(element) {
        const updater = this.state.view === 0 ? updateQuestionLayout : updateAnswerLayout;
        const item = this.state.view === 0
            ? this.props.store.getIn(['questions', Number(element.dataset.id) || element.dataset.id])
            : this.props.store.getIn(['answers', Number(element.dataset.id) || element.dataset.id]);
        const mainElement = this.refs['prerender-' + element.dataset.id];
        const elementRect = element.getBoundingClientRect();
        const mainElementRect = mainElement.getBoundingClientRect();
        this.context.store.dispatch(updater(
            item.merge({
                height: mainElementRect.height / this.verticalCentimeter,
                decorativeHeight: elementRect.height / this.verticalCentimeter,
            }),
            this.props.store.get('elementId'),
        ));
    }

    prerenderCallback(element) {
        if (element) {
            const images = element.getElementsByTagName('IMG');
            if (images.length === 0)
                setTimeout(this.elementLoaded, 10, element);
            else {
                let counter = 0;
                const done = ({ target: img }) => {
                    counter++;
                    img.removeEventListener('load', done);
                    img.removeEventListener('error', done);
                    if (counter === images.length)
                        setTimeout(this.elementLoaded, 10, element);
                };
                _.forEach(
                    images,
                    img => {
                        if (img.complete) {
                            done({ target: img });
                        }
                        else {
                            img.addEventListener('load', done);
                            img.addEventListener('error', done);
                        }
                    },
                );
            }
        }
    }

    scoresPrerenderCallback(element) {
        if (element) {
            const updater = this.state.view === 0 ? updateQuestionLayout : updateAnswerLayout;
            const item = this.state.view === 0
                ? this.props.store.getIn(['questions', Number(element.dataset.id)])
                : this.props.store.getIn(['answers', Number(element.dataset.id)]);
            const elementRect = element.getBoundingClientRect();
            this.context.store.dispatch(updater(
                item.set('scores', fromJS(_.mapKeys(_.map(
                    element.querySelectorAll('.score'),
                    score => {
                        const rect = score.getBoundingClientRect();
                        return {
                            top: ((rect.top + rect.bottom) / 2 - elementRect.top),
                            right: (elementRect.width - ((rect.left + rect.right) / 2 - elementRect.left)),
                            score: Number.parseFloat(score.dataset.score),
                            id: Number.parseInt(score.dataset.scoreId),
                        };
                    },
                ), score => score.id))),
                this.props.store.get('elementId'),
            ));
        }
    }

    setEdit(id) {
        this.setState({ edit: id });
    }

    setActive(id) {
        if (id === this.state.active)
            return;
        this.setState({ active: id });
        if (id !== this.state.edit)
            this.setEdit(null);
    }
    render() {
        const items = this.state.view === 0 ? this.props.store.get('questions') : this.props.store.get('answers');
        if (!items)
            return null;
        let sortedItems = _.sortBy(items.toJS(), ["index"]);
        const updater = this.state.view === 0 ? updateQuestionLayout : updateAnswerLayout;
        const pages = Math.max((items.map(item => item.get('page')).max() || -1) + 2, 0);
        const pageWidth = (
            this.props.store.getIn(['settings', 'width']) -
            this.props.store.getIn(['settings', 'marginRight']) -
            this.props.store.getIn(['settings', 'marginLeft'])
        );
        const currentPage = { distance: Infinity };
        const pagesRect = this.refs.pages ? this.refs.pages.getBoundingClientRect() : null;
        _.forEach(new Array(pages), (__, page) => {
            if (!pagesRect || !this.refs['page-' + page])
                return;
            const rect = this.refs['page-' + page].getBoundingClientRect();
            const distance = Math.abs((rect.left + rect.right) / 2 - (pagesRect.left + pagesRect.right) / 2);
            if (distance < currentPage.distance)
                _.merge(currentPage, { distance, page });
        });
        const checkedMaterials = {};
        return <><div style={{ width: '100%' }}>
            <div
                ref='navigatorContainer'
                style={{
                    width: '8.5em',
                    float: 'right',
                    height: this.props.store.getIn(['settings', 'height']) + 'cm',
                }}>
                <div ref='navigator'>
                    <div style={{ height: '5em' }}>
                        <button
                            style={{
                                ...(this.state.view === 0 ? styles.activeRightTabButton : styles.rightTabButton),
                                width: '100%',
                            }}
                            onClick={() => this.setState({ view: 0, mode: undefined })}>
                            {window.gettext('Questions')}
                            &nbsp;
                            {this.state.view === 0 && !this.props.store.get('locked')
                                ? <i
                                    style={{ cursor: 'pointer' }}
                                    className='fa-long-arrow-down'
                                    onClick={event => {
                                        event.stopPropagation();
                                        if (!window.confirm(window.gettext(
                                            'Are you sure you wanna copy layout from questions to answers?',
                                        )))
                                            return;
                                        this.context.store.dispatch(updateAnswerLayout(
                                            this.props.store.get('answers').map(item => item.merge({
                                                top: this.props.questions[item.id].top,
                                                right: this.props.questions[item.id].right,
                                                width: this.props.questions[item.id].width,
                                                height: this.props.questions[item.id].height,
                                                page: this.props.questions[item.id].page,
                                            })),
                                            this.props.store.get('elementId'),
                                        ));
                                    }}>
                                </i>
                                : null
                            }
                        </button>
                        <button
                            style={{
                                ...(this.state.view === 1 ? styles.activeRightTabButton : styles.rightTabButton),
                                width: '100%',
                            }}
                            onClick={() => this.setState({ view: 1 })}>
                            {window.gettext('Answers')}
                            &nbsp;
                            {this.state.view === 1 && !this.props.store.get('locked')
                                ? <i
                                    style={{ cursor: 'pointer' }}
                                    className='fa-long-arrow-up'
                                    onClick={event => {
                                        event.stopPropagation();
                                        if (!window.confirm(window.gettext(
                                            'Are you sure you wanna copy layout from answers to questions?',
                                        )))
                                            return;
                                        this.context.store.dispatch(updateQuestionLayout(
                                            this.props.store.get('questions').map(item => item.merge({
                                                ...item,
                                                top: this.props.answers[item.id].top,
                                                right: this.props.answers[item.id].right,
                                                width: this.props.answers[item.id].width,
                                                height: this.props.answers[item.id].height,
                                                page: this.props.answers[item.id].page,
                                            })),
                                            this.props.store.get('elementId'),
                                        ));
                                    }}>
                                </i>
                                : null
                            }
                        </button>
                    </div>
                    <div
                        style={{
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, 25%)',
                        }}>
                        {_.map(new Array(pages), (__, page) => <div
                            key={page}
                            ref={'page-handle-' + page}
                            style={{
                                height: '3em',
                                border: '.0625em solid #cacaca',
                                margin: '0',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: page === currentPage.page ? styles.thirdColor : 'white',
                                color: page === currentPage.page ? 'white' : 'black',
                                cursor: 'pointer',
                            }}
                            onClick={() => {
                                this.refs['page-' + page].scrollIntoView({ inline: 'center' });
                                setTimeout(this.forceUpdate.bind(this), 1);
                            }}
                            onDragEnter={event => {
                                if (_.includes(event.dataTransfer.types, 'question-id')) {
                                    this.refs['page-' + page].scrollIntoView({ inline: 'center' });
                                    setTimeout(this.forceUpdate.bind(this), 1);
                                }
                            }}>
                            {(page + 1).persian()}
                        </div>)}
                    </div>
                </div>
            </div>
            <div
                ref='toolsContainer'
                style={{
                    padding: '.25em',
                    backgroundColor: '#eaeaea',
                    float: 'left',
                    height: this.props.store.getIn(['settings', 'height']) + 'cm',
                    width: '3.25em',
                    display: 'flex',
                    flexFlow: 'column',
                }}>
                <div ref='tools'>
                    <button
                        style={{
                            ...styles.button,
                            marginTop: '.25em',
                            marginBottom: '.25em',
                            marginLeft: '.25em',
                            marginRight: '.25em',
                            width: '3em',
                            minWidth: undefined,
                            height: '3em',
                            cursor: 'pointer',
                        }}
                        onClick={() => this.setState({ scale: this.state.scale === 1 ? .25 : 1 })}>
                        <i className={`fa ${this.state.scale === 1 ? 'fa-search-minus' : 'fa-search-plus'} fa-lg`}></i>
                    </button>
                    {!this.props.store.get('locked')
                        ? [
                            <button
                                key='1'
                                style={{
                                    ...styles.button,
                                    marginTop: '.25em',
                                    marginBottom: '.25em',
                                    marginLeft: '.25em',
                                    marginRight: '.25em',
                                    width: '3em',
                                    minWidth: undefined,
                                    height: '3em',
                                    cursor: 'pointer',
                                }}
                                onClick={() => {
                                    if (!window.confirm(window.gettext('Are you sure you wanna reorder layout?')))
                                        return;
                                    this.context.store.dispatch(updater(
                                        items.filter(item => item.get('question_id')).map(item => item.merge({
                                            top: null,
                                            page: null,
                                        })).toList(),
                                        this.props.store.get('elementId'),
                                    ));
                                }}>
                                <i className='fa-arrows-v fa-lg'></i>
                            </button>,
                            <button
                                key='2'
                                style={{
                                    ...styles.button,
                                    marginTop: '.25em',
                                    marginBottom: '.25em',
                                    marginLeft: '.25em',
                                    marginRight: '.25em',
                                    width: '3em',
                                    minWidth: undefined,
                                    height: '3em',
                                    cursor: 'pointer',
                                }}
                                onClick={() => {
                                    this.context.store.dispatch(setLayoutOptions({ settings: { template: 0 } }, this.props.store.get('elementId')));
                                    this.refreshLayout(items, updater)
                                    this.context.store.dispatch(setLayoutOptions({ settings: { template:this.state.template } }, this.props.store.get('elementId')));
                                }}>
                                <i className='fa-arrows fa-lg'></i>
                            </button>,
                            <button
                                key='3'
                                style={{
                                    ...styles.button,
                                    marginTop: '.25em',
                                    marginBottom: '.25em',
                                    marginLeft: '.25em',
                                    marginRight: '.25em',
                                    width: '3em',
                                    minWidth: undefined,
                                    height: '3em',
                                    cursor: 'pointer',
                                }}
                                onClick={async () => {
                                    if (!window.confirm(window.gettext('Are you sure you wanna reset all questions and answers to their orignal content?')))
                                        return;
                                    const response = await this.context.store.dispatch(request({
                                        path: '/question/?limit=10000&id=' + items.filter(
                                            item => item.get('question_id'),
                                        ).map(item => item.get('question_id')).toArray().join(','),
                                    }, undefined, undefined, undefined, undefined, undefined, true));
                                    this.context.store.dispatch(_.map(
                                        response.results,
                                        question => updateQuestion(question, this.props.store.get('elementId').split(':')[0] + ':questions'),
                                    ));
                                }}>
                                <i className='fa-refresh fa-lg'></i>
                            </button>,
                            <button
                                key='4'
                                style={{
                                    ...styles.button,
                                    marginTop: '.25em',
                                    marginBottom: '.25em',
                                    marginLeft: '.25em',
                                    marginRight: '.25em',
                                    width: '3em',
                                    minWidth: undefined,
                                    height: '3em',
                                    cursor: 'pointer',
                                }}
                                onClick={() => {
                                    if (!window.confirm(window.gettext('Are you sure you wanna reorder question numbers?')))
                                        return;

                                    console.log("exam:", items[2]);
                                    // debugger;

                                    this.context.store.dispatch(reorder(
                                        _.map(_.sortBy(_.filter(items.toJS(), 'question_id'), ['page', 'right', 'top']), 'id'),
                                        this.props.store.get('elementId'),
                                    ));
                                }}>
                                <i className='fa-sort-numeric-asc fa-lg'></i>
                            </button>,
                            <button
                                key='5'
                                style={{
                                    ...styles.button,
                                    marginTop: '.25em',
                                    marginBottom: '.25em',
                                    marginLeft: '.25em',
                                    marginRight: '.25em',
                                    width: '3em',
                                    minWidth: undefined,
                                    height: '3em',
                                    cursor: 'pointer',
                                }}
                                onClick={() => {
                                    const template = Number(prompt('Enter template number', this.props.store.getIn(['settings', 'template'])));
                                    if (!window.confirm(window.gettext('Are you sure you want to change template?')))
                                        return;
                                    this.context.store.dispatch(setLayoutOptions({ settings: { template } }, this.props.store.get('elementId')));
                                    this.setState({...this.state,template})
                                }}>
                                <i className='fa-insert-template fa-lg'></i>
                            </button>,
                            this.state.view === 1 && this.props.store.get('type') === 2
                                ? <button
                                    key='5'
                                    style={{
                                        ...(this.state.mode === 'scores' ? styles.activeButton : styles.button),
                                        marginTop: '.25em',
                                        marginBottom: '.25em',
                                        marginLeft: '.25em',
                                        marginRight: '.25em',
                                        width: '3em',
                                        minWidth: undefined,
                                        height: '3em',
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => {
                                        this.setState({ mode: this.state.mode === 'scores' ? undefined : 'scores' });
                                    }}>
                                    <i className='fa-pencil-square-o fa-lg'></i>
                                </button>
                                : null,
                        ]
                        : null
                    }
                    <button
                        style={{
                            ...styles.button,
                            marginTop: '.25em',
                            marginBottom: '.25em',
                            marginLeft: '.25em',
                            marginRight: '.25em',
                            width: '3em',
                            minWidth: undefined,
                            height: '3em',
                            cursor: 'pointer',
                        }}
                        onClick={async () => printExamination(
                            { ...this.props.store.toJS(), layout: this.props.store.get('settings').toJS() },
                            {
                                source: this.state.view,
                                contentProcessors: this.contentProcessors,
                            },
                        )}>
                        <i className='fa-print fa-lg'></i>
                    </button>
                </div>
            </div>
            <div
                ref='pages'
                style={{
                    width: 'calc(100% - 13em)',
                    overflowX: 'hidden',
                    float: 'right',
                }}>
                <div
                    style={{
                        display: 'flex',
                        transform: `scale(${this.state.scale})`,
                        transformOrigin: '100% 0',
                        width: `${100 / this.state.scale}%`,
                        flexWrap: this.state.scale === 1 ? 'nowrap' : 'wrap',
                    }}>
                    <div
                        ref={element => {
                            if (element) {
                                this.horizontalCentimeter = element.getBoundingClientRect().width;
                                this.verticalCentimeter = element.getBoundingClientRect().height;
                            }
                        }}
                        style={{
                            opacity: '0',
                            top: '0',
                            right: '0',
                            width: '1cm',
                            height: '1cm',
                            position: 'absolute',
                            pointerEvents: 'none',
                        }}>
                    </div>
                    {_.map(new Array(pages), (__, page) => {
                        this.contentProcessors = this.contentProcessors || [];
                        if (
                            !this.contentProcessors[page] ||
                            this.contentProcessors[page].original !== this.props.contentProcessor ||
                            this.contentProcessors[page].noPageCounter !== this.props.store.getIn(['settings', 'noPageCounter', String(this.state.view)])
                        )
                            this.contentProcessors[page] = {
                                original: this.props.contentProcessor,
                                processor: this.props.contentProcessor.bind(
                                    undefined,
                                    this.props.store.getIn(['settings', 'noPageCounter', String(this.state.view)])
                                        ? this.props.store.getIn(['settings', 'noPageCounter', String(this.state.view), String(page)])
                                            ? ''
                                            : page + 1 - this.props.store.getIn(['settings', 'noPageCounter', String(this.state.view)]).
                                                count((value, p) => value && Number(p) < page)
                                        : page + 1,
                                ),
                                noPageCounter: this.props.store.getIn(['settings', 'noPageCounter', String(this.state.view)]),
                            };
                        return <div
                            key={page}
                            ref={'page-' + page}
                            style={{
                                position: 'relative',
                                height: this.props.store.getIn(['settings', 'height']) + 'cm',
                                width: this.props.store.getIn(['settings', 'width']) + 'cm',
                                minWidth: this.props.store.getIn(['settings', 'width']) + 'cm',
                                border: '.0625em dashed black',
                                boxSizing: 'border-box',
                                overflow: 'hidden',
                                marginLeft: '.25em',
                                marginRight: '.25em',
                            }}
                            onDragEnter={event => {
                                if (_.includes(event.dataTransfer.types, 'question-id')) {
                                    event.preventDefault();
                                    this.refs['page-' + page].scrollIntoView({ inline: 'center' });
                                    setTimeout(this.forceUpdate.bind(this), 1);
                                }
                            }}
                            onDragOver={event => {
                                if (_.includes(event.dataTransfer.types, 'question-id')) {
                                    event.preventDefault();
                                    event.dataTransfer.dropEffect = 'all';
                                }
                            }}
                            onDrop={event => {
                                const questionId = Number(event.dataTransfer.getData('question-id'));
                                const offsetX = Number(event.dataTransfer.getData('offsetX'));
                                const offsetY = Number(event.dataTransfer.getData('offsetY'));
                                if (questionId) {
                                    this.refs['page-' + page].scrollIntoView({ inline: 'center' });
                                    setTimeout(this.forceUpdate.bind(this), 1);
                                    const item = items.get(questionId);
                                    const rect = event.currentTarget.getBoundingClientRect();
                                    const currentOffsetX = event.clientX - rect.left;
                                    const currentOffsetY = event.clientY - rect.top;
                                    let top = (currentOffsetY - offsetY - 2) / this.verticalCentimeter;
                                    let right = this.props.store.getIn(['settings', 'width']) - (
                                        (currentOffsetX - offsetX) / this.horizontalCentimeter + item.get('width')
                                    );
                                    const width = item.get('width');
                                    const height = item.get('height');
                                    top = Math.min(
                                        Math.max(top, this.props.store.getIn(['settings', 'marginTop'])),
                                        this.props.store.getIn(['settings', 'height']) - this.props.store.getIn(['settings', 'marginBottom']) - height,
                                    );
                                    right = Math.min(
                                        Math.max(right, this.props.store.getIn(['settings', 'marginRight'])),
                                        this.props.store.getIn(['settings', 'width']) - this.props.store.getIn(['settings', 'marginLeft']) - width,
                                    );
                                    this.context.store.dispatch(updater(
                                        item.merge({
                                            page,
                                            top: top - this.props.store.getIn(['settings', 'marginTop']),
                                            right: right - this.props.store.getIn(['settings', 'marginRight']),
                                        }),
                                        this.props.store.get('elementId'),
                                    ));
                                }
                            }}>
                            {this.props.store.get('type') === 1
                                ? null
                                : <div
                                    style={{
                                        position: 'absolute',
                                        bottom: this.props.store.getIn(['settings', 'marginBottom']) + 'cm',
                                        right: this.props.store.getIn(['settings', 'marginRight']) + 'cm',
                                        width: pageWidth + 'cm',
                                        height: '0',
                                        borderBottom: '.5mm solid black',
                                        boxSizing: 'border-box',
                                    }}>
                                </div>
                            }
                            <div
                                key={'top-panel-' + page}
                                style={{
                                    opacity: '.08',
                                    textAlign: 'center',
                                    position: 'absolute',
                                    top: '.25em',
                                    width: '100%',
                                    left: '0',
                                    zIndex: '3',
                                    ':hover': {
                                        opacity: '.5',
                                    },
                                }}>
                                {!this.props.store.get('locked')
                                    ? [
                                        <i
                                            key='1'
                                            style={{ cursor: 'pointer', float: 'right', marginRight: '.5em' }}
                                            className='fa-plus'
                                            onClick={() => {
                                                this.context.store.dispatch(updater(
                                                    items.filter(item => item.get('page') >= 0 && item.get('page') >= page).
                                                        map(item => item.set('page', item.get('page') + 1)).toList(),
                                                    this.props.store.get('elementId'),
                                                ));
                                            }}>

                                        </i>,
                                        <i
                                            key='2'
                                            style={{ cursor: 'pointer', float: 'left', marginLeft: '.5em' }}
                                            className='fa-plus'
                                            onClick={() => {
                                                this.context.store.dispatch(updater(
                                                    items.filter(item => item.get('page') >= 0 && item.get('page') > page).
                                                        map(item => item.set('page', item.get('page') + 1)).toList(),
                                                    this.props.store.get('elementId'),
                                                ));
                                            }}>
                                        </i>,
                                        <i
                                            key='3'
                                            style={{ cursor: 'pointer' }}
                                            className='fa-object-ungroup'
                                            onClick={() => this.context.store.dispatch(addElement(page, this.state.view, this.props.store.get('elementId')))}>
                                        </i>,
                                        ' ',
                                        <i
                                            key='4'
                                            style={{ cursor: 'pointer' }}
                                            className='fa-arrows-v'
                                            onClick={() => {
                                                if (!window.confirm(window.interpolate(window.gettext(
                                                    'Are you sure you wanna reorder layout for page %(page)s?',
                                                ), { page: (page + 1).persian() }, true)))
                                                    return;
                                                this.context.store.dispatch(updater(
                                                    items.filter(
                                                        item => item.get('page') === page && item.get('question_id'),
                                                    ).map(item => item.set('top', null)).toList(),
                                                    this.props.store.get('elementId'),
                                                ));
                                            }}>
                                        </i>,
                                        ' ',
                                        <i
                                            key='5'
                                            style={{ cursor: 'pointer' }}
                                            className='fa-arrows'
                                            onClick={() => {
                                                if (!window.confirm(window.interpolate(window.gettext(
                                                    'Are you sure you wanna refresh layout for page %(page)s?',
                                                ), { page: (page + 1).persian() }, true)))
                                                    return;
                                                this.context.store.dispatch(setLayoutOptions({ settings: { template:0 } }, this.props.store.get('elementId')));
                                                this.context.store.dispatch(updater(
                                                    items.filter(item => item.get('page') === page && item.get('question_id')).map(item => item.merge({
                                                        top: null,
                                                        right: null,
                                                        width: null,
                                                        height: null
                                                    })).toList(),
                                                    this.props.store.get('elementId'),
                                                ));
                                                this.context.store.dispatch(setLayoutOptions({ settings: { template:this.state.template } }, this.props.store.get('elementId')));
                                            }}>
                                        </i>,
                                        ' ' + window.interpolate(
                                            window.gettext('Page %(page)s'),
                                            { page: (page + 1).persian() },
                                            true,
                                        ) + ' ',
                                        <i
                                            key='6'
                                            style={{ cursor: 'pointer' }}
                                            className='fa-insert-template'
                                            onClick={() => {
                                                this.context.store.dispatch(setLayoutOptions(
                                                    {
                                                        settings: {
                                                            noStylePages: {
                                                                [this.state.view]: {
                                                                    [page]: !this.props.store.getIn(['settings', 'noStylePages', String(this.state.view), String(page)]),
                                                                }
                                                            }
                                                        }
                                                    },
                                                    this.props.store.get('elementId'),
                                                ));
                                            }}>
                                        </i>,
                                        ' ',
                                        <i
                                            key='7.5'
                                            style={{ cursor: 'pointer' }}
                                            className='fa-hash'
                                            onClick={() => {
                                                this.context.store.dispatch(setLayoutOptions(
                                                    {
                                                        settings: {
                                                            noPageCounter: {
                                                                [this.state.view]: {
                                                                    [page]: !this.props.store.getIn(['settings', 'noPageCounter', String(this.state.view), String(page)]),
                                                                }
                                                            }
                                                        }
                                                    },
                                                    this.props.store.get('elementId'),
                                                ));
                                            }}>
                                        </i>,
                                        ' ',
                                        <i
                                            key='7'
                                            style={{ cursor: 'pointer' }}
                                            className='fa-table'
                                            onClick={async () => {
                                                await this.context.store.dispatch(setLayoutOptions(
                                                    {
                                                        settings: {
                                                            split: {
                                                                [this.state.view]: {
                                                                    [page]: !this.props.store.getIn(['settings', 'split', String(this.state.view), String(page)]),
                                                                }
                                                            }
                                                        }
                                                    },
                                                    this.props.store.get('elementId'),
                                                ));
                                                await this.context.store.dispatch(updater(
                                                    items.filter(item => item.get('page') === page && item.get('question_id')).map(item => item.merge({
                                                        top: null,
                                                        right: null,
                                                        width: null,
                                                        height: null,
                                                    })).toList(),
                                                    this.props.store.get('elementId'),
                                                ));
                                            }}>
                                        </i>,
                                        ' ',
                                        <i
                                            key='8'
                                            style={{
                                                cursor: items.filter(item => item.get('page') >= 0 && item.get('page') === page).size === 0
                                                    ? 'pointer'
                                                    : 'not-allowed',
                                            }}
                                            className='fa-trash'
                                            onClick={() => {
                                                if (items.filter(item => item.get('page') >= 0 && item.get('page') === page).size)
                                                    return;
                                                this.context.store.dispatch(updater(
                                                    items.filter(item => item.get('page') >= 0 && item.get('page') > page).
                                                        map(item => item.set('page', item.get('page') - 1)).toList(),
                                                    this.props.store.get('elementId'),
                                                ));
                                            }}>
                                        </i>,
                                    ]
                                    : null
                                }
                            </div>
                            {sortedItems.filter((item) => {
                                return this.isInPage(item, page)
                            }).map(
                                (item) => {
                                    const renderMaterial = !checkedMaterials[item?.materialId] && item?.material;
                                    console.log(item?.material)
                                    checkedMaterials[item?.materialId] = true;
                                    if (item?.height === null) {
                                        const split = this.props.store.getIn(['settings', 'split', String(this.state.view), String(page)]);
                                        let availableWidth = (
                                            this.props.store.getIn(['settings', 'width']) -
                                            this.props.store.getIn(['settings', 'marginRight']) -
                                            this.props.store.getIn(['settings', 'marginLeft'])
                                        );
                                        if (split) {
                                            availableWidth = (availableWidth - this.props.store.getIn(['settings', 'marginMiddle'])) / 2;
                                        }
                                        return <div
                                            key={'prerender-' + item?.id}
                                            ref={this.prerenderCallback}
                                            data-id={item?.id}
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                position: 'absolute',
                                                top: item?.top + this.props.store.getIn(['settings', 'marginTop']) + 'cm',
                                                right: item?.right + this.props.store.getIn(['settings', 'marginRight']) + 'cm',
                                            }}>
                                            {renderMaterial
                                                ? <div
                                                    style={{
                                                        fontSize: '12pt',
                                                        backgroundColor: '#eaeaea',
                                                        display: 'inline-block',
                                                        paddingTop: '.2em',
                                                        paddingBottom: '.2em',
                                                        paddingLeft: '.7em',
                                                        paddingRight: '.7em',
                                                    }}>
                                                    ∴  {item?.material?.persian()}
                                                </div>
                                                : null
                                            }
                                            <div
                                                ref={'prerender-' + item?.id}
                                                style={{
                                                    display: 'inline-block',
                                                    width: availableWidth + 'cm',
                                                    minHeight: '.6cm',
                                                    padding: this.props.store.getIn(['settings', 'padding']) + 'cm',
                                                    border: this.props.store.get('type') === 1 ? '.0125em dotted #cacaca' : '.5mm solid black',
                                                    boxSizing: 'border-box',
                                                    ...styles.content,
                                                }}
                                                dangerouslySetInnerHTML={{ __html: this.contentProcessors[page].processor(item?.content) }}
                                            />
                                        </div>;
                                    }
                                    else if (item?.scores === null) {
                                        // debugger;
                                        return <div
                                            key={'prerender-' + item?.id}
                                            ref={this.scoresPrerenderCallback}
                                            data-id={item?.id}
                                            style={{
                                                position: 'absolute',
                                                top: item?.top + this.props.store.getIn(['settings', 'marginTop']) + 'cm',
                                                right: item?.right + this.props.store.getIn(['settings', 'marginRight']) + 'cm',
                                            }}>
                                            {renderMaterial
                                                ? <div
                                                    style={{
                                                        fontSize: '12pt',
                                                        backgroundColor: '#eaeaea',
                                                        display: 'inline-block',
                                                        paddingTop: '.2em',
                                                        paddingBottom: '.2em',
                                                        paddingLeft: '.7em',
                                                        paddingRight: '.7em',
                                                    }}>
                                                    ∴  {item?.material?.persian()}
                                                </div>
                                                : null
                                            }
                                            <div
                                                style={{
                                                    width: item?.width + 'cm',
                                                    height: item?.height + 'cm',
                                                    padding: this.props.store.getIn(['settings', 'padding']) + 'cm',
                                                    border: this.props.store.get('type') === 1 ? '.0125em dotted #cacaca' : '.5mm solid black',
                                                    boxSizing: 'border-box',
                                                    ...styles.content,
                                                }}
                                                dangerouslySetInnerHTML={{ __html: this.contentProcessors[page].processor(item?.content) }}
                                            />
                                        </div>;
                                    }
                                    else {
                                        return <Item
                                            key={item?.id}
                                            ref={'item-' + page + '-' + item?.id}
                                            renderMaterial={renderMaterial}
                                            locked={this.props.store.get('locked')}
                                            store={this.props.store.getIn(['settings', 'noStylePages', String(this.state.view), String(page)])
                                                ?
                                                this.props.store.get('settings').merge({
                                                    marginTop: 0,
                                                    marginBottom: 0,
                                                    marginLeft: 0,
                                                    marginRight: 0,
                                                })
                                                : this.props.store.get('settings')
                                            }
                                            type={this.props.store.get('type')}
                                            item={items.find((el) => el.get("id") == item?.id)}
                                            edit={this.state.edit === item?.id}
                                            active={this.state.active === item?.id}
                                            mode={this.state.mode}
                                            page={page}
                                            currentPage={currentPage.page}
                                            container={this.refs['page-' + page]}
                                            updater={updater}
                                            horizontalCentimeter={this.horizontalCentimeter}
                                            verticalCentimeter={this.verticalCentimeter}
                                            contentProcessor={this.contentProcessors[page].processor}
                                            setEdit={this.setEdit}
                                            setActive={this.setActive}
                                            elementId={this.props.store.get('elementId')}
                                        />
                                    }
                                },
                            )}
                        </div>;
                    })}
                </div>
            </div>
        </div ></>;
    }
}
